import styled from 'styled-components';
import { RedirectionModalStyled } from '../../RedirectionModalStyled';

export const RedirectionModalStyledOV = styled(RedirectionModalStyled)``;
